/**
 * Approach API service
 */

import { fetchStrapi } from './strapi';

export interface ApproachFeature {
  text: string;
  icon: string;
  iconColor: string;
  link?: string;
}

export interface Approach {
  badgeText: string;
  heading: string;
  subtitle: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
  features: ApproachFeature[];
}

/**
 * Fetch approach data from Strapi
 */
export async function fetchApproach(): Promise<Approach | null> {
  try {
    const response = await fetchStrapi<any>('/approach?populate=*');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      badgeText: data.badgeText || '',
      heading: data.ueberschrift || '',
      subtitle: data.untertitel || '',
      primaryButtonText: data.primaerButtonText || '',
      primaryButtonLink: data.primaerButtonLink || '',
      secondaryButtonText: data.sekundaerButtonText || '',
      secondaryButtonLink: data.sekundaerButtonLink || '',
      features: (data.merkmale || []).map((m: any) => ({
        text: m.text,
        icon: m.icon,
        iconColor: m.iconFarbe,
        link: m.link,
      })),
    };
  } catch (error) {
    console.error('Error fetching approach from Strapi:', error);
    return null;
  }
}
